import { Route, Routes } from 'react-router-dom'
import './assets/styles.scss'
import { Header, Footer } from '../src/views/index.js'
import Toaster from '../src/views/Toaster.jsx'
import {
  Movies,
  TvShows,
  SearchResults,
  MediaDetails,
  Contact,
  About,
  MyList,
} from '../src/components/index.js'

function App() {
  return (
    <div className='App '>
      <Header />
      <Routes>
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<About />} />
        <Route path='/my-list' element={<MyList />} />
        <Route path='/show/:id' element={<MediaDetails />} />
        <Route path='/searched-movies' element={<SearchResults />} />
        <Route path='/tv-shows' element={<TvShows />} />
        <Route path='/' element={<Movies />} />
      </Routes>
      <Footer />
      <Toaster />
    </div>
  )
}

export default App
